<template>
  <div class="w-6 h-6 lg:w-8 lg:h-8 mr-2">
    <button class="text-white p-1 w-6 h-6 lg:p-2 lg:w-8 lg:h-8 border-current rounded"
            :class="[ disabled ? 'cursor-default bg-gray-500' : ' bg-gray-800 hover:bg-gray-500' ]"
            :disabled="disabled"
            @click.prevent.stop="showMenu = !showMenu">
      <IconAdd></IconAdd>
    </button>

    <div class="absolute z-10 right-0 lg:right-auto mt-2 mr-4 w-auto rounded-md shadow-lg"
         :class="{ hidden: !showMenu }">
      <div class="rounded-md bg-white shadow-xs px-1">
        <div class="p-1">
          <div class="border-b w-full flex items-center justify-between">
            <div class="p-1 mr-2">Parent</div>
            <div class="flex flex-nowrap gap-2 py-2">
              <button class="flex items-center pl-2 pr-3 py-2 border border-transparent text-sm leading-4 font-medium rounded-md text-white bg-gray-800 hover:bg-gray-500 focus:outline-none focus:border-gray-700 focus:shadow-outline-gray active:bg-gray-700"
                      @click="$emit('addParentRowBelow')">
                <span class="w-4 h-4 sm:mr-2">
                  <IconArrowDown></IconArrowDown>
                </span>
                <span class="hidden sm:inline-block">Below</span>
              </button>
              <button class="flex items-center pl-2 pr-3 py-2 border border-transparent text-sm leading-4 font-medium rounded-md text-white bg-gray-800 hover:bg-gray-500 focus:outline-none focus:border-gray-700 focus:shadow-outline-gray active:bg-gray-700"
                      v-if="showChildOptions"
                      @click="$emit('addParentRowChild')">
                <span class="w-4 h-4 sm:mr-2">
                  <IconArrowDownRight></IconArrowDownRight>
                </span>
                <span class="hidden sm:inline-block">Child</span>
              </button>
            </div>
          </div>

          <div class="border-b w-full flex items-center justify-between">
            <div class="p-1 mr-2">New</div>
            <div class="flex flex-nowrap gap-2 py-2">
              <button class="flex items-center pl-2 pr-3 py-2 border border-transparent text-sm leading-4 font-medium rounded-md text-white bg-gray-800 hover:bg-gray-500 focus:outline-none focus:border-gray-700 focus:shadow-outline-gray active:bg-gray-700"
                      @click="$emit('addBlankRowBelow')">
                <span class="w-4 h-4 sm:mr-2">
                  <IconArrowDown></IconArrowDown>
                </span>
                <span class="hidden sm:inline-block">Below</span>
              </button>
              <button class="flex items-center pl-2 pr-3 py-2 border border-transparent text-sm leading-4 font-medium rounded-md text-white bg-gray-800 hover:bg-gray-500 focus:outline-none focus:border-gray-700 focus:shadow-outline-gray active:bg-gray-700"
                      v-if="showChildOptions"
                      @click="$emit('addBlankRowChild')">
                <span class="w-4 h-4 sm:mr-2"><IconArrowDownRight></IconArrowDownRight></span>
                <span class="hidden sm:inline-block">Child</span>
              </button>
            </div>
          </div>

          <div class="border-b w-full flex items-center  justify-between">
            <div class="p-1 mr-2">Import</div>
            <div class="flex flex-nowrap gap-2 py-2">
              <button class="flex items-center pl-2 pr-3 py-2 border border-transparent text-sm leading-4 font-medium rounded-md text-white bg-gray-800 hover:bg-gray-500 focus:outline-none focus:border-gray-700 focus:shadow-outline-gray active:bg-gray-700"
                      @click="$emit('importRowBelow')">
                <span class="w-4 h-4 sm:mr-2">
                  <IconArrowDown></IconArrowDown>
                </span>
                <span class="hidden sm:inline-block">Below</span>
              </button>
              <button class="flex items-center pl-2 pr-3 py-2 border border-transparent text-sm leading-4 font-medium rounded-md text-white bg-gray-800 hover:bg-gray-500 focus:outline-none focus:border-gray-700 focus:shadow-outline-gray active:bg-gray-700"
                      v-if="showChildOptions"
                      @click="$emit('importRowChild')">
                <span class="w-4 h-4 sm:mr-2">
                  <IconArrowDownRight></IconArrowDownRight>
                </span>
                <span class="hidden sm:inline-block">Child</span>
              </button>
            </div>
          </div>

          <div v-if="showReferenceButton" class="w-full flex items-center justify-between">
            <div class="p-1 mr-2">Reference</div>
            <div class="flex flex-nowrap gap-2 py-2">
              <button class="flex items-center pl-2 pr-3 py-2 border border-transparent text-sm leading-4 font-medium rounded-md text-white bg-gray-800 hover:bg-gray-500 focus:outline-none focus:border-gray-700 focus:shadow-outline-gray active:bg-gray-700"
                      @click="$emit('addLinkedRowBelow')">
                <span class="w-4 h-4 sm:mr-2">
                  <IconArrowDown></IconArrowDown>
                </span>
                <span class="hidden sm:inline-block">Below</span>
              </button>
              <button class="flex items-center pl-2 pr-3 py-2 border border-transparent text-sm leading-4 font-medium rounded-md text-white bg-gray-800 hover:bg-gray-500 focus:outline-none focus:border-gray-700 focus:shadow-outline-gray active:bg-gray-700"
                      v-if="showChildOptions"
                      @click="$emit('addLinkedRowChild')">
                <span class="w-4 h-4 sm:mr-2"><IconArrowDownRight></IconArrowDownRight></span>
                <span class="hidden sm:inline-block">Child</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import IconAdd from '@/components/icons/IconAdd';
import IconArrowDown from '@/components/icons/IconArrowDown';
import IconArrowDownRight from '@/components/icons/IconArrowDownRight';

export default {
  name: 'RowAddMenu',
  components: {
    IconAdd,
    IconArrowDown,
    IconArrowDownRight
  },
  props: {
    rowNumber: String,
    showChildOptions: {
      type: Boolean,
      default: true
    },
    options: Array,
    disabled: {
      type: Boolean,
      default: false
    },
    showReferenceButton: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      showMenu: false
    };
  },
  methods: {
    hideMenu: function() {
      this.showMenu = false;
    }
  },
  created: function() {
    window.addEventListener('click', this.hideMenu);
  },
  destroyed: function() {
    window.removeEventListener('click', this.hideMenu);
  }
};
</script>